export default {
  title: 'Envoyer un message',
  businessLine: 'Secteur d\'activité',
  contract: 'Contrat',
  object: 'Objet',
  subject: 'Sujet',
  assignments: 'Destinataire (facultatif)',
  specify: 'Préciser',
  contractNumber: 'Numéro de contrat (facultatif)',
  contractNumberErrorMessage: 'Le format n\'est pas valide.',
  sendMessageButton: 'Envoyer',
  cancelMessageButton: 'Annuler',
  messageSentSnackbar: 'Message envoyé',
  disabled: 'Désactivé',
};
